// modules/reporteCliente/routes/ReporteClienteRoutes.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import ReporteClientePage   from "../pages/ReporteClientePage";
import ReporteClienteListadoPage from "../pages/ReporteClienteListadoPage";
import ReporteClienteDetalle from "../pages/ReporteClienteDetalle";
import ReporteClienteResumenPage from "../pages/ReporteClienteResumenPage";

const ReporteClienteRoutes = () => (
  <Routes>
    <Route path=""                              element={<ReporteClientePage />} />
    <Route path="listado"                       element={<ReporteClienteListadoPage />} />
    <Route path=":cod_servicio_cliente/resumen" element={<ReporteClienteResumenPage />} />
    <Route path=":cod_servicio_cliente"         element={<ReporteClienteDetalle />} />
  </Routes>
);

export default ReporteClienteRoutes;